import { Separator } from '@qr-front/ui/components/Separator'
import {
	openingHoursStateAtom,
	sharedOpeningHoursStateAtom,
	weekDaysAreSharedAtom,
} from 'features/generator/contentFormSections/OpeningHoursForm/openingHoursState'
import { selectedTabAtom } from 'features/generator/contentFormSections/OpeningHoursForm/TabNavigation'
import { useTranslatedWeekDays } from 'features/generator/contentFormSections/OpeningHoursForm/useTranslatedWeekDays'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { Fragment } from 'react/jsx-runtime'

export const OpenHoursSection = () => {
	const weekDaysAreShared = useAtomValue(weekDaysAreSharedAtom)
	const openHours = useAtomValue(openingHoursStateAtom)
	const sharedOpenHours = useAtomValue(sharedOpeningHoursStateAtom)
	const selectedTab = useAtomValue(selectedTabAtom)
	const weekDays = useTranslatedWeekDays()
	const t = useTranslations()

	const dayDateRanges = weekDays
		.filter((day, index) => {
			if (weekDaysAreShared && index > 4) return false
			const dayData = weekDaysAreShared
				? sharedOpenHours[day.key]
				: openHours[day.key]
			return dayData?.isActive
		})
		.map((day) => {
			const source = weekDaysAreShared
				? sharedOpenHours[day.key]
				: openHours[day.key]

			return {
				dayName: day.label,
				dateRanges: source?.dateRanges ?? [],
			}
		})

	const formatTime = (
		d: Date,
		mode: 'am-pm' | '24h',
		t: (key: string) => string,
	) => {
		const h = d.getHours()
		const m = d.getMinutes().toString().padStart(2, '0')

		if (mode === 'am-pm') {
			const hour12 = (h % 12 || 12).toString().padStart(2, '0')
			const ampm =
				h >= 12
					? t('generator__content_form_section__opening_hours__tabs__pm')
					: t('generator__content_form_section__opening_hours__tabs__am')

			return `${hour12}:${m} ${ampm}`
		}

		return `${h.toString().padStart(2, '0')}:${m}`
	}

	return (
		<div className="p-2">
			<ul className="flex flex-col gap-4">
				{selectedTab === 'open-24h' ? (
					<li className="font-body text-10">
						{t(
							'generator__content_form_section__opening_hours__tabs__open_24h',
						)}
					</li>
				) : (
					dayDateRanges.map((day, index) => (
						<Fragment key={day.dayName}>
							<li className="flex items-start justify-between gap-2 font-body text-10">
								<span className="shrink-0 whitespace-nowrap">
									{day.dayName}:
								</span>

								<ul className="flex flex-col gap-2 text-right word-break-fix">
									{day.dateRanges.map((range, rangeIndex) => (
										<li key={rangeIndex}>
											{formatTime(
												new Date(range.start),
												selectedTab === 'am-pm' ? 'am-pm' : '24h',
												t,
											)}{' '}
											-{' '}
											{formatTime(
												new Date(range.end),
												selectedTab === 'am-pm' ? 'am-pm' : '24h',
												t,
											)}
										</li>
									))}
								</ul>
							</li>
							{index < dayDateRanges.length - 1 && (
								<Separator collapse={false} />
							)}
						</Fragment>
					))
				)}
			</ul>
		</div>
	)
}
